import { render, staticRenderFns } from "./NumericResponse.vue?vue&type=template&id=3f0bfda1&scoped=true&"
import script from "./NumericResponse.vue?vue&type=script&lang=js&"
export * from "./NumericResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0bfda1",
  null
  
)

export default component.exports